
import TerrainWeb from './TerrainWeb';


export default function App() {
  return <TerrainWeb />;
}
